<script>
import { Pie } from "vue-chartjs";
import "@/plugins/chart";

export default {
    name: "PieChart",
    extends: Pie,
    props: {
        title: {
            type: String,
            default: null,
        },
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        exerciseExtraData: {
            type: Boolean,
            default: false
        },
        legendDisplay: {
            type: Boolean,
            default: true
        },
        disableHover: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets,
            }
        },
        options(vm = this) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                ...(vm.disableHover ? { events: [] } : {}),
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            display: false
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            display: false
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    display: vm.legendDisplay,
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                    }
                },
                title: {
                    display: !!vm.title,
                    text: vm.title
                },
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                },
                animation: {
                    onComplete: function () {
                        let chartInstance = this.chart;
                        let ctx = chartInstance.ctx;

                        ctx.font = 'bold 14px "Outfit", sans-serif';
                        ctx.textAlign = "center";
                        ctx.textBaseline = "middle";

                        chartInstance.data.datasets.forEach(function (dataset, i) {
                            let meta = chartInstance.controller.getDatasetMeta(i);

                            meta.data.forEach(function (arc, index) {
                                let model = arc._model;
                                let total = dataset.data.reduce((sum, val) => sum + val, 0);
                                let value = dataset.data[index];
                                let percentage = total ? ((value / total) * 100).toFixed(1) : 0;

                                let midRadius = model.innerRadius + (model.outerRadius - model.innerRadius) / 2;
                                let midAngle = model.startAngle + (model.endAngle - model.startAngle) / 2;

                                let x = model.x + midRadius * Math.cos(midAngle);
                                let y = model.y + midRadius * Math.sin(midAngle);

                                let text = percentage + "%";

                                // 👇 primero borde blanco
                                ctx.lineWidth = 3;
                                ctx.strokeStyle = "#fff";
                                ctx.strokeText(text, x, y);

                                // 👇 luego texto negro encima
                                ctx.fillStyle = "#333";
                                ctx.fillText(text, x, y);
                            });
                        });
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            if (vm.exerciseExtraData) {
                                const label = data.labels[tooltipItem.index];
                                const total = data.datasets[0].data[tooltipItem.index];
                                const extraData = data.datasets[0].extraData[tooltipItem.index];
                                const sets = extraData.sets || 0;
                                const reps = extraData.reps || 0;

                                return `${label}: ${total}E\n(${sets}S, ${reps}R)`
                            }

                            const dataset = data.datasets[tooltipItem.datasetIndex];
                            const total = dataset.data.reduce((sum, value) => sum + value, 0);
                            const currentValue = dataset.data[tooltipItem.index];
                            const percentage = total ? ((currentValue / total) * 100).toFixed(1) : 0;
                            return `${data.labels[tooltipItem.index]}: ${percentage}%`;
                        }
                    }
                }
            }
        }
    },
    data() {
        return {
            renderKey: null,
        }
    },
    mounted() {
        this.draw();
    },
    methods: {
        draw() {
            const vm = this
            const key = JSON.stringify({
                labels: vm.labels,
                datasets: vm.datasets,
                title: vm.title,
                legendDisplay: vm.legendDisplay,
                disableHover: vm.disableHover,
                exerciseExtraData: vm.exerciseExtraData,
            })
            if (key === vm.renderKey) return
            vm.renderKey = key
            vm.renderChart(vm.data, vm.options);
        }
    },
    watch: {
        data() {
            this.draw();
        },
        options() {
            this.draw();
        }
    }
};
</script>